module.exports = __webpack_public_path__ + "assets/1a7d7a36c39d76fb49a80f1b51baf065.woff2";


//////////////////
// WEBPACK FOOTER
// ../~/@fontsource/roboto/files/roboto-greek-ext-700-normal.woff2
// module id = 2633
// module chunks = 121